export const etkinlikler = [
  {
    "id": "ananne-babanne-dedelerimiz",
    "title": "Anneanne, Babaanne ve Dedelerimiz",
    "image": "/files/images/l15122018125218407.JPG",
    "description": "Anneanne, Babaanne ve DedelerimizTutum Yatırım ve Yerli Malı Haftamız anneanne, babaanne ve dedelerimizin katılımı ile zenginleşti. Büyüklerimiz çocuklarımızla ile birlikte birçok etkinlik gerçekleştirdi. Hikayeler anlatarak miniklerimizin hayal dünyalarına yeni pencereler açmalarını, bilmeceler sorarak eğlenceli bir şekilde beyin fırtınası yapmalarını, tekerlemeler söyleyerek de dil beceri çalışmaları yapmalarını sağladılar. Ayrıca günümüzde aktif olarak kullandığımız birçok teknolojik aletin eski versiyonlarını çocuklara tanıtarak, anılarını paylaştılar. Her şeyden önemlisi gözlerindeki ışıltı, ellerindeki şefkatli dokunuşları ve kocaman yürekleri ile anaokulumuzu sevgiyle ısıttılar.",
    "gallery": [
      "/files/images/l15122018125218407.JPG",
      "/files/images/l15122018125218500.JPG",
      "/files/images/l15122018125218813.JPG",
      "/files/images/l15122018125318142.JPG",
      "/files/images/l15122018125318454.JPG",
      "/files/images/l15122018125318797.JPG",
      "/files/images/l15122018125418110.JPG",
      "/files/images/l15122018125418407.JPG",
      "/files/images/l15122018125418688.JPG",
      "/files/images/l15122018125418985.JPG",
      "/files/images/l15122018125518313.JPG",
      "/files/images/l15122018125518610.JPG",
      "/files/images/l15122018125518907.JPG",
      "/files/images/l15122018125618219.JPG",
      "/files/images/l15122018125618532.JPG",
      "/files/images/l15122018125618844.JPG",
      "/files/images/l15122018125718125.JPG",
      "/files/images/l15122018125718454.JPG",
      "/files/images/l15122018125718750.JPG",
      "/files/images/l1512201812581832.JPG",
      "/files/images/l15122018125818329.JPG",
      "/files/images/l15122018125818625.JPG",
      "/files/images/l15122018125818907.JPG",
      "/files/images/l15122018125918204.JPG",
      "/files/images/l15122018125918516.JPG",
      "/files/images/l15122018125918813.JPG",
      "/files/images/l1512201812019125.JPG",
      "/files/images/l1512201812019422.JPG",
      "/files/images/l1512201812019735.JPG",
      "/files/images/l151220181211947.JPG",
      "/files/images/l1512201812119344.JPG",
      "/files/images/l1512201812119625.JPG",
      "/files/images/l1512201812119969.JPG",
      "/files/images/l1512201812219266.JPG",
      "/files/images/l1512201812219594.JPG",
      "/files/images/l1512201812219875.JPG",
      "/files/images/l1512201812319188.JPG",
      "/files/images/l1512201812319579.JPG",
      "/files/images/l1512201812319875.JPG",
      "/files/images/l1512201812419188.JPG",
      "/files/images/l1512201812419500.JPG",
      "/files/images/l1512201812419829.JPG",
      "/files/images/l1512201812519125.JPG",
      "/files/images/l1512201812519422.JPG",
      "/files/images/l1512201812519719.JPG",
      "/files/images/l151220181261994.JPG",
      "/files/images/l1512201812619454.JPG",
      "/files/images/l1512201812619766.JPG",
      "/files/images/l151220181271932.JPG",
      "/files/images/l1512201812719360.JPG",
      "/files/images/l1512201812719641.JPG",
      "/files/images/l1512201812719969.JPG",
      "/files/images/l1512201812819282.JPG",
      "/files/images/l1512201812819579.JPG",
      "/files/images/l1512201812819875.JPG",
      "/files/images/l1512201812919188.JPG",
      "/files/images/l1512201812919485.JPG",
      "/files/images/l1512201812919797.JPG",
      "/files/images/l15122018121019157.JPG",
      "/files/images/l15122018121019485.JPG",
      "/files/images/l15122018121019766.JPG",
      "/files/images/l1512201812111963.JPG",
      "/files/images/l15122018121119391.JPG",
      "/files/images/l15122018121119755.JPG",
      "/files/images/l1512201812121979.JPG",
      "/files/images/l15122018121219375.JPG",
      "/files/images/l15122018121219657.JPG",
      "/files/images/l15122018121319235.JPG",
      "/files/images/l15122018121319532.JPG"
    ],
    "video": ""
  },
  {
    "id": "tutum-yatirim-ve-turk-mallari-haftasi",
    "title": "Tutum, Yatırım ve Türk Malları Haftası",
    "image": "/files/images/l1312201810319717.jpg",
    "description": "Tutum, Yatırım ve Türk Malları HaftasıÇocuklarımıza ihtiyacımız olan almayı, kalanı ile birikim yapmayı, bilinçli tüketiciliği öğrettiğimiz, yerli üretimin ve tüketimin önemini vurguladığımız 12-18 Aralık Tutum, Yatırım ve Türk Malları Haftası kutlu olsun.",
    "gallery": [
      "/files/images/l1312201810319717.jpg",
      "/files/images/l1312201810319889.jpg",
      "/files/images/l131220181032977.jpg",
      "/files/images/l1312201810329264.jpg",
      "/files/images/l1312201810329389.jpg",
      "/files/images/l1312201810329561.jpg",
      "/files/images/l1312201810329717.jpg",
      "/files/images/l1312201810329905.jpg",
      "/files/images/l131220181033914.jpg",
      "/files/images/l131220181033992.jpg"
    ],
    "video": ""
  },
  {
    "id": "gelisim-anaokulunda-arkadaslik-haftasi",
    "title": "GELİŞİM ANAOKULUNDA ARKADAŞLIK HAFTASI",
    "image": "/files/images/l19112018163526830.jpg",
    "description": "GELİŞİM ANAOKULUNDA ARKADAŞLIK HAFTASIHangi yaşta olursa olsun çocuklar, arkadaşlığın özel bir paylaşım olduğunu bilirler. Arkadaş edinme ve arkadaşlıkları sürdürebilme becerilerini kazanmada çocukların etrafındaki yetişkinlerin bilinçli tutumları büyük önem taşımaktadır. Bu nedenle çocuklarımızda arkadaşlık bilincini geliştirme, arkadaşlığın önemini kavrayabilme, iyi arkadaş kavramı altında paylaşımın ve yardımseverliğin gelişimini destekleyebilme adına 12 – 16 Kasım tarihleri arasında okulumuzda “ARKADAŞLIK HAFTASI” etkinlikleri planlanmıştır. Bu etkinliklerde,Hafta boyunca sınıflarda arkadaşlık üzerine sohbetler,Gün boyu okulda arkadaşlık şarkılarının dinlenmesi,Sabah sohbetlerinde çocukların arkadaşlarının olumlu özeliklerini ifade etmeleri ,Bahçede öğle arası çocukların birbirlerine boyamalar ve kartlar yaparak hediye etmeleri,Arkadaşlık konulu “Oyuncak Hikayesi 1” filminin izlenmesi,Serbest kıyafet gününde herkesin beyaz giysiler giyip “HEPİMİZ FARKLIYIZ VE ARKADAŞIZ” duygusunun verilmesi,Arkadaşlık  konulu Rehberlik Panosu önünde fotoğraf çekimi ve resim çerçevelerinin çocuklar tarafından süslenmesi.Sabah sporunda arkadaşlık dansının yapılması,Çocukların arkadaşlarına olan duygularını anlatan mektupların paylaşılması,“Benim İçin Arkadaşlık” konulu aile katılımı etkinliği,çalışmaları yapılmıştır.",
    "gallery": [
      "/files/images/l19112018163526830.jpg",
      "/files/images/l19112018163526970.jpg",
      "/files/images/l19112018163626111.jpg",
      "/files/images/l19112018163626251.jpg",
      "/files/images/l19112018163626408.jpg",
      "/files/images/l19112018163626548.jpg",
      "/files/images/l19112018163626705.jpg",
      "/files/images/l19112018163626845.JPG",
      "/files/images/l19112018163626892.JPG",
      "/files/images/l19112018163626955.JPG",
      "/files/images/l1911201816372633.JPG",
      "/files/images/l19112018163726111.JPG",
      "/files/images/l19112018163726189.JPG",
      "/files/images/l19112018163726236.JPG",
      "/files/images/l19112018163726330.JPG",
      "/files/images/l19112018163726470.JPG",
      "/files/images/l19112018163726658.JPG",
      "/files/images/l19112018163726783.JPG",
      "/files/images/l19112018163726939.JPG",
      "/files/images/l19112018163826142.JPG",
      "/files/images/l19112018163826330.JPG",
      "/files/images/l19112018163826392.JPG",
      "/files/images/l19112018163826455.JPG",
      "/files/images/l19112018163826517.JPG",
      "/files/images/l19112018163826564.JPG",
      "/files/images/l19112018163826611.JPG",
      "/files/images/l19112018163826689.JPG",
      "/files/images/l19112018163826751.JPG",
      "/files/images/l19112018163826814.JPG",
      "/files/images/l19112018163826892.JPG",
      "/files/images/l19112018163826955.JPG"
    ],
    "video": "https://www.youtube.com/embed/SeEN4Q8GFSo?ecver=1"
  },
  {
    "id": "okul-oncesi-donemde-ozbakim-becerileri",
    "title": "Okul Öncesi Dönemde Özbakım Becerileri",
    "image": "/files/images/l19112018165823267.JPG",
    "description": "Okul Öncesi Dönemde Özbakım Becerileri17 Kasım 2018 Cumartesi günü Anaokulu Rehber Öğretmenimiz tarafından “ Okul Öncesi Dönemde Özbakım Becerileri” konulu veli atölye çalışmasını keyifli bir şekilde gerçekleştirdik.Atölye çalışmasına katılan tüm velilerimize teşekkür ederiz.",
    "gallery": [
      "/files/images/l19112018165823267.JPG",
      "/files/images/l19112018165823454.JPG",
      "/files/images/l19112018165823626.JPG",
      "/files/images/l19112018165823813.JPG"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-ataturku-anma",
    "title": "10 KASIM ATATÜRK'Ü ANMA",
    "image": "/files/images/l1311201816351814.JPG",
    "description": "10 KASIM ATATÜRK'Ü ANMAAramızdan ayrılışının 80. yıldönümünde gerçekleştirdiğimiz anma töreninde, Atamızı saygı, minnet ve özlemle andık.",
    "gallery": [
      "/files/images/l1311201816351814.JPG",
      "/files/images/l1311201816351876.JPG",
      "/files/images/l1311201816351970.JPG",
      "/files/images/l1311201816451110.JPG",
      "/files/images/l1311201816451298.JPG",
      "/files/images/l1311201816451459.JPG",
      "/files/images/l1311201816451642.JPG",
      "/files/images/l1311201816451814.JPG",
      "/files/images/l13112018165511.JPG",
      "/files/images/l1311201816551142.JPG",
      "/files/images/l1311201816551314.JPG",
      "/files/images/l1311201816551486.JPG",
      "/files/images/l1311201816551642.JPG",
      "/files/images/l1311201816551782.JPG",
      "/files/images/l1311201816551923.JPG",
      "/files/images/l131120181665179.JPG",
      "/files/images/l1311201816651204.JPG",
      "/files/images/l1311201816651329.JPG",
      "/files/images/l1311201816651454.JPG",
      "/files/images/l1311201816651628.JPG",
      "/files/images/l1311201816651782.JPG",
      "/files/images/l1311201816651954.JPG",
      "/files/images/l131120181675195.JPG",
      "/files/images/l1311201816751251.JPG",
      "/files/images/l1311201816751376.JPG",
      "/files/images/l1311201816751517.JPG",
      "/files/images/l1311201816751673.JPG",
      "/files/images/l1311201816751892.JPG",
      "/files/images/l131120181685117.JPG",
      "/files/images/l1311201816851157.JPG",
      "/files/images/l1311201816851298.JPG",
      "/files/images/l1311201816851454.JPG",
      "/files/images/l1311201816851626.JPG",
      "/files/images/l1311201816851767.JPG",
      "/files/images/l1311201816851845.JPG",
      "/files/images/l1311201816851939.JPG"
    ],
    "video": ""
  },
  {
    "id": "cumhuriyet-balosu",
    "title": "Cumhuriyet Balosu",
    "image": "/files/images/l311020188514316.JPG",
    "description": "Cumhuriyet BalosuCumhuriyet Bayramı coşkusunu Anasınıfımızda Gelişim öğrencileri olarak doysıya yaşadık. 95. yıl dönümünde 29 Ekim Cumhuriyet Bayramı'nı hafta boyunca süren renkli ve anlamlı etkinliklerle kutladık.",
    "gallery": [
      "/files/images/l311020188514316.JPG",
      "/files/images/l3110201885143344.JPG",
      "/files/images/l3110201885143657.JPG",
      "/files/images/l31102018852430.JPG",
      "/files/images/l3110201885243329.JPG",
      "/files/images/l3110201885243641.JPG",
      "/files/images/l31102018853430.JPG",
      "/files/images/l3110201885343329.JPG",
      "/files/images/l3110201885343641.JPG",
      "/files/images/l3110201885343922.JPG",
      "/files/images/l3110201885443235.JPG",
      "/files/images/l3110201885443547.JPG",
      "/files/images/l3110201885443860.JPG",
      "/files/images/l3110201885543204.JPG",
      "/files/images/l3110201885543516.JPG",
      "/files/images/l3110201885543813.JPG",
      "/files/images/l3110201885643141.JPG",
      "/files/images/l3110201885643438.JPG",
      "/files/images/l3110201885643735.JPG",
      "/files/images/l311020188574347.JPG",
      "/files/images/l3110201885743375.JPG",
      "/files/images/l3110201885743719.JPG",
      "/files/images/l311020188584316.JPG",
      "/files/images/l3110201885843313.JPG",
      "/files/images/l3110201885843626.JPG",
      "/files/images/l3110201885843985.JPG",
      "/files/images/l3110201885943344.JPG",
      "/files/images/l3110201885943672.JPG",
      "/files/images/l3110201885943985.JPG",
      "/files/images/l311020188044313.JPG",
      "/files/images/l311020188044610.JPG",
      "/files/images/l311020188044891.JPG",
      "/files/images/l311020188144204.JPG",
      "/files/images/l311020188144563.JPG",
      "/files/images/l311020188144922.JPG",
      "/files/images/l311020188244219.JPG",
      "/files/images/l311020188244516.JPG",
      "/files/images/l311020188244813.JPG",
      "/files/images/l311020188344172.JPG",
      "/files/images/l311020188344469.JPG"
    ],
    "video": ""
  },
  {
    "id": "anaokulu-secim-gunu",
    "title": "Anaokulu Seçim Günü",
    "image": "/files/images/l25102018111135202.JPG",
    "description": "Anaokulu Seçim GünüÖğrenci ve öğretmenlerimizle 26 Ekim’de yapılacak olan “Cumhuriyet Balosu” pastamız için seçim yaptık. Okulumuzda oluşturduğumuz seçim atmosferi ile öğrencilerimiz ilk demokrasi deneyimini yaşadı.",
    "gallery": [
      "/files/images/l25102018111135202.JPG",
      "/files/images/l25102018111135592.JPG",
      "/files/images/l2510201811123545.JPG",
      "/files/images/l25102018111235420.JPG",
      "/files/images/l25102018111235798.JPG",
      "/files/images/l25102018111335155.JPG",
      "/files/images/l25102018111335483.JPG"
    ],
    "video": ""
  },
  {
    "id": "minik-ellerden-tursu",
    "title": "Minik Ellerden Turşu",
    "image": "/files/images/l810201817168790.jpg",
    "description": "Minik Ellerden TurşuMinik ellerden kış hazırlıkları başladı. Lezzetli turşularımızı kurduk. Tadına bakmak için sabırsızlanıyoruz.",
    "gallery": [
      "/files/images/l810201817168790.jpg",
      "/files/images/l8102018171789.jpg",
      "/files/images/l810201817178165.jpg",
      "/files/images/l810201817178322.jpg",
      "/files/images/l810201817178478.jpg",
      "/files/images/l810201817178634.jpg",
      "/files/images/l810201817178728.jpg",
      "/files/images/l810201817178900.jpg",
      "/files/images/l81020181718887.jpg",
      "/files/images/l8102018184250444.jpg",
      "/files/images/l8102018184250616.jpg",
      "/files/images/l8102018184250756.jpg",
      "/files/images/l8102018184250944.jpg"
    ],
    "video": ""
  },
  {
    "id": "onlar-bize-emanet",
    "title": "Onlar Bize Emanet",
    "image": "/files/images/l5102018185316611.jpg",
    "description": "Onlar Bize EmanetGörsel Sanatlar dersinde anaokulu öğrencilerimizle yaptığımız seramik mama kapları ve okulumuzun hediye ettiği kedi mamalarını sokaktaki dostlarımıza ulaştırdık.",
    "gallery": [
      "/files/images/l5102018185316611.jpg",
      "/files/images/l5102018185316767.jpg",
      "/files/images/l5102018185316907.jpg",
      "/files/images/l510201818541633.jpg",
      "/files/images/l5102018185416158.jpg",
      "/files/images/l5102018185416204.jpg",
      "/files/images/l5102018185416329.jpg",
      "/files/images/l5102018185416470.jpg",
      "/files/images/l5102018185416642.jpg",
      "/files/images/l5102018185416783.jpg"
    ],
    "video": ""
  },
  {
    "id": "dogayi-kesfet",
    "title": "Doğayı Keşfet",
    "image": "/files/images/l510201817370509.jpg",
    "description": "Doğayı KeşfetOkulöncesi sınıflarımız bahçemizde doğayı yakından inceleme ve keşfetme fırsatı yakalıyorlar…",
    "gallery": [
      "/files/images/l510201817370509.jpg",
      "/files/images/l510201817370665.jpg",
      "/files/images/l510201817370806.jpg",
      "/files/images/l510201817370978.jpg"
    ],
    "video": ""
  },
  {
    "id": "gune-muzikle-baslamak",
    "title": "Güne Müzikle Başlamak",
    "image": "/files/images/l110201822351675.png",
    "description": "Güne Müzikle BaşlamakGüne müzikle başlamak çok güzel.6 yaş grubu öğrencilerimizle bahçede boomwhackers (müzikal borular), marakas ve davullarla ritim orkestrası oluşturduk. Çocuklar bahçede özgürce müzik yapmanın keyfini çıkardılar.",
    "gallery": [
      "/files/images/l110201822351675.png",
      "/files/images/l1102018223516700.png",
      "/files/images/l1102018223616528.png"
    ],
    "video": ""
  },
  {
    "id": "montessori",
    "title": "Montessori",
    "image": "/images2/img2_files/logo.jpg",
    "description": "MontessoriMontessori, çocuğun bireysel beceri ve ilgi alanlarına uygun olacak şekilde kendi kendine yetebilmesi, çocuğun kendini birey olarak görmesi, dilediğinde hata yaparak doğruyu bulmasıdır. Montessori'de materyaller doğru kategorize edilir, çocuğun istediği anda ulaşabileceği şekilde konumlandırılır. Materyal seçim hakkı çocukta olur. Böylelikle çocuklar en kalıcı öğrenim tekniği olan yaparak, yaşayarak ve keşfederek öğrenmeyi deneyimlerler.",
    "gallery": [],
    "video": "http://dizihitplayer.xyz/player/flex/3e1d9ed48c864d11b03c679786134f2a"
  },
  {
    "id": "miniklerimizin-ilk-gunu",
    "title": "Miniklerimizin İlk Günü",
    "image": "/files/images/l1192018131947149.JPG",
    "description": "Miniklerimizin İlk GünüMiniklerimizle, uzun yıllar sürecek olan eğitim öğretim hayatlarına Güney Gelişim Anaokulu'nda \"Merhaba\" dedik. Tüm miniklerimize mutlu, sağlıklı ve başarılı bir eğitim hayatı diliyoruz.",
    "gallery": [
      "/files/images/l1192018131947149.JPG",
      "/files/images/l1192018131947446.JPG",
      "/files/images/l1192018131947758.JPG",
      "/files/images/l119201813204739.JPG",
      "/files/images/l1192018132047305.JPG",
      "/files/images/l1192018132047586.JPG",
      "/files/images/l1192018132047899.JPG",
      "/files/images/l1192018132147196.JPG",
      "/files/images/l1192018132147495.JPG",
      "/files/images/l1192018132147821.JPG",
      "/files/images/l1192018132247180.JPG",
      "/files/images/l1192018132247524.JPG",
      "/files/images/l1192018132247836.JPG",
      "/files/images/l1192018132347133.JPG",
      "/files/images/l1192018132347446.JPG",
      "/files/images/l1192018132347742.JPG",
      "/files/images/l119201813244771.JPG",
      "/files/images/l1192018132447352.JPG",
      "/files/images/l1192018132447649.JPG",
      "/files/images/l1192018132447946.JPG",
      "/files/images/l1192018132547211.JPG",
      "/files/images/l1192018132547508.JPG",
      "/files/images/l1192018132547789.JPG",
      "/files/images/l1192018132647102.JPG",
      "/files/images/l1192018132647383.JPG",
      "/files/images/l1192018132647711.JPG",
      "/files/images/l11920181327478.JPG",
      "/files/images/l1192018132747305.JPG",
      "/files/images/l1192018132747602.JPG",
      "/files/images/l1192018132747899.JPG",
      "/files/images/l1192018132847211.JPG",
      "/files/images/l1192018132847524.JPG",
      "/files/images/l1192018132847852.JPG",
      "/files/images/l1192018132947149.JPG",
      "/files/images/l1192018132947414.JPG",
      "/files/images/l1192018132947758.JPG",
      "/files/images/l119201813304755.JPG",
      "/files/images/l1192018133047164.JPG",
      "/files/images/l1192018133047477.JPG",
      "/files/images/l1192018133047836.JPG",
      "/files/images/l1192018133147117.JPG",
      "/files/images/l1192018133147430.JPG",
      "/files/images/l1192018133147774.JPG",
      "/files/images/l1192018133247118.JPG",
      "/files/images/l1192018133247414.JPG",
      "/files/images/l1192018133247727.JPG",
      "/files/images/l119201813334714.JPG",
      "/files/images/l1192018133347336.JPG",
      "/files/images/l1192018133347649.JPG",
      "/files/images/l1192018133347930.JPG",
      "/files/images/l1192018133447242.JPG",
      "/files/images/l1192018133447539.JPG",
      "/files/images/l1192018133447821.JPG",
      "/files/images/l1192018133547117.JPG",
      "/files/images/l1192018133547430.JPG",
      "/files/images/l1192018133547774.JPG",
      "/files/images/l1192018133647102.JPG",
      "/files/images/l1192018133647399.JPG",
      "/files/images/l1192018133647680.JPG",
      "/files/images/l1192018133647977.JPG",
      "/files/images/l1192018133747289.JPG",
      "/files/images/l1192018133747586.JPG",
      "/files/images/l1192018133747867.JPG",
      "/files/images/l1192018133847149.JPG",
      "/files/images/l1192018133847477.JPG",
      "/files/images/l1192018133847774.JPG",
      "/files/images/l119201813394755.JPG",
      "/files/images/l1192018133947383.JPG",
      "/files/images/l1192018133947680.JPG",
      "/files/images/l1192018133947961.JPG",
      "/files/images/l1192018134047242.JPG",
      "/files/images/l1192018134047524.JPG",
      "/files/images/l1192018134047836.JPG",
      "/files/images/l1192018134147133.JPG",
      "/files/images/l1192018134147461.JPG",
      "/files/images/l1192018134147774.JPG",
      "/files/images/l119201813424786.JPG",
      "/files/images/l1192018134247383.JPG",
      "/files/images/l1192018134247727.JPG",
      "/files/images/l119201813434739.JPG",
      "/files/images/l1192018134347383.JPG",
      "/files/images/l1192018134347664.JPG",
      "/files/images/l1192018134347961.JPG",
      "/files/images/l1192018134447289.JPG",
      "/files/images/l1192018134447602.JPG",
      "/files/images/l1192018134447899.JPG",
      "/files/images/l1192018134547211.JPG",
      "/files/images/l1192018134547539.JPG"
    ],
    "video": ""
  },
  {
    "id": "back-to-school",
    "title": "Back to School",
    "image": "/files/images/l49201816627901.JPG",
    "description": "Back to SchoolOryantasyon haftası kapsamında kreş grubumuz İngilizce öğretmenleriyle tanışıp okulumuz bahçesinde keyifli vakit geçirdiler.",
    "gallery": [
      "/files/images/l49201816627901.JPG",
      "/files/images/l49201816727229.JPG",
      "/files/images/l49201816727557.JPG",
      "/files/images/l49201816727885.JPG",
      "/files/images/l49201816827182.JPG",
      "/files/images/l49201816827541.JPG",
      "/files/images/l49201816827838.JPG",
      "/files/images/l49201816927151.JPG",
      "/files/images/l49201816927432.JPG",
      "/files/images/l49201816927729.JPG",
      "/files/images/l49201816102741.JPG",
      "/files/images/l492018161027323.JPG",
      "/files/images/l492018161027635.JPG",
      "/files/images/l492018161027948.JPG",
      "/files/images/l492018161127244.JPG",
      "/files/images/l492018161127573.JPG"
    ],
    "video": ""
  },
  {
    "id": "okulda-ilk-gunum",
    "title": "Okulda İlk Günüm",
    "image": "/files/images/l392018161753161.JPG",
    "description": "Okulda İlk Günüm\"Uyum Haftası\" kapsamında en miniklerimiz olan kreş öğrencilerimizle eğitim-öğretim yılına başladık.",
    "gallery": [
      "/files/images/l392018161753161.JPG",
      "/files/images/l392018161753489.JPG",
      "/files/images/l392018161753833.JPG",
      "/files/images/l392018161853130.JPG",
      "/files/images/l392018161853442.JPG",
      "/files/images/l392018161853708.JPG",
      "/files/images/l39201816195323.JPG",
      "/files/images/l392018161953368.JPG",
      "/files/images/l392018161953692.JPG",
      "/files/images/l39201816205321.JPG",
      "/files/images/l392018162053317.JPG",
      "/files/images/l392018162053614.JPG",
      "/files/images/l392018162053927.JPG",
      "/files/images/l392018162153239.JPG",
      "/files/images/l392018162153536.JPG",
      "/files/images/l392018162153817.JPG",
      "/files/images/l392018162657566.JPG"
    ],
    "video": ""
  },
  {
    "id": "avustralya-kitasi-festivali",
    "title": "AVUSTRALYA KITASI FESTİVALİ",
    "image": "/files/images/l155201892343887.jpg",
    "description": "AVUSTRALYA KITASI FESTİVALİNisan ayı kıtamız Avustralya’dan  3 yaş öğrencilerimiz Arjantin ; 4 yaş öğrencilerimiz Bolivya, Şili, Brezilya ve 5 yaş öğrencilerimiz Kolombiya, Ekvador, Yeni Zelanda ülkelerini tanıyıp birbirlerine tanıttılar.",
    "gallery": [
      "/files/images/l155201892343887.jpg",
      "/files/images/l15520189244312.jpg",
      "/files/images/l155201892443121.jpg",
      "/files/images/l155201892443246.jpg",
      "/files/images/l155201892443356.jpg",
      "/files/images/l155201892443449.jpg",
      "/files/images/l155201892443528.jpg",
      "/files/images/l155201892443621.jpg",
      "/files/images/l155201892443731.jpg",
      "/files/images/l155201892443856.jpg",
      "/files/images/l155201892443965.jpg"
    ],
    "video": ""
  },
  {
    "id": "anne-baba-tutumlari-etkili-iletisim-oyun-ve-oyuncaklar-resimli-cocuk-kitaplari",
    "title": "“Anne – Baba Tutumları, Etkili İletişim, Oyun ve Oyuncaklar, Resimli Çocuk Kitapları”",
    "image": "/files/images/l35201813426455.jpg",
    "description": "“Anne – Baba Tutumları, Etkili İletişim, Oyun ve Oyuncaklar, Resimli Çocuk Kitapları”Anaokulu Rehber Öğretmenimiz ve Okul Psikoloğumuz liderliğinde “Anne – Baba Tutumları, Etkili İletişim, Oyun ve Oyuncaklar, Resimli Çocuk Kitapları” konulu seminer çalışmalarımız velilerimizin keyifli katılımları ile gerçekleşmiştir.",
    "gallery": [
      "/files/images/l35201813426455.jpg",
      "/files/images/l35201813426595.jpg",
      "/files/images/l35201813426720.jpg",
      "/files/images/l35201813426830.jpg",
      "/files/images/l35201813426955.jpg",
      "/files/images/l3520181343695.jpg",
      "/files/images/l35201813436205.jpg",
      "/files/images/l35201813436314.jpg",
      "/files/images/l35201813436423.jpg",
      "/files/images/l35201813436564.jpg"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/306bcda4f89840362d4ddf8b8705e9c1"
  },
  {
    "id": "hat-party",
    "title": "Hat Party",
    "image": "/files/images/l1142018223320209.jpg"
  },
  {
    "id": "kuzey-amerika-kitasi",
    "title": "Kuzey Amerika Kıtası",
    "image": "/files/images/l104201818113848.jpg",
    "description": "Kuzey Amerika KıtasıMart ayı kıtamız Kuzey Amerika’dan  3 yaş öğrencilerimiz Panama, Porto Riko ; 4 yaş öğrencilerimiz Costa Riko, Küba, Kanada ve 5 yaş öğrencilerimiz Meksika, Amerika Birleşik Devletleri,  Bahamalar ülkelerini tanıyıp birbirlerine tanıttılar.",
    "gallery": [
      "/files/images/l104201818113848.jpg",
      "/files/images/l104201818113973.jpg",
      "/files/images/l10420181812398.jpg",
      "/files/images/l104201818123207.jpg",
      "/files/images/l104201818123254.jpg",
      "/files/images/l104201818123348.jpg",
      "/files/images/l104201818123379.jpg",
      "/files/images/l104201818123426.jpg",
      "/files/images/l104201818123520.jpg"
    ],
    "video": ""
  },
  {
    "id": "dunya-tiyatrolar-gunu",
    "title": "Dünya Tiyatrolar Günü",
    "image": "/files/images/l2932018142338205.jpg",
    "description": "Dünya Tiyatrolar Günü5 yaş öğrencilerimiz “27 Mart Dünya Tiyatro Günü” sebebiyle hazırladıkları “Çekirdeksiz Domatesler”, “Balıklarımız Ölmesin”, “Kral ve Çiçek Tohumları” isimli canlandırmalarını büyük bir heyecan ile tüm okul arkadaşlarına sundular.",
    "gallery": [
      "/files/images/l2932018142338205.jpg",
      "/files/images/l2932018142338767.jpg",
      "/files/images/l2932018142438361.jpg",
      "/files/images/l2932018142438986.jpg",
      "/files/images/l2932018142538580.jpg",
      "/files/images/l2932018142538611.jpg"
    ],
    "video": ""
  },
  {
    "id": "afrika-kitasi",
    "title": "Afrika Kıtası",
    "image": "/files/images/l133201813952215.jpg",
    "description": "Afrika KıtasıŞubat ayı kıtamız Afrika’dan3 yaş öğrencilerimiz Nijerya, Fas ; 4 yaş öğrencilerimiz Kongo, Cezayir, Mısır ve 5 yaş öğrencilerimiz Kenya, Sudan,Güney Afrika ülkelerini tanıyıp birbirlerine tanıttılar.",
    "gallery": [
      "/files/images/l133201813952215.jpg",
      "/files/images/l133201813952309.jpg",
      "/files/images/l133201813952449.jpg",
      "/files/images/l133201813952605.jpg",
      "/files/images/l133201813952730.jpg"
    ],
    "video": ""
  },
  {
    "id": "aralik-ayi-son-hafta",
    "title": "ARALIK AYI SON HAFTA",
    "image": "/files/images/l412018153316437.jpg",
    "description": "ARALIK AYI SON HAFTASon derece verimli ve keyifli geçen 2017’nin son haftasındaki aktivitelerde de çocuklarımız ve öğretmenlerimiz çok eğlendiler.",
    "gallery": [
      "/files/images/l412018153316437.jpg",
      "/files/images/l412018153316952.jpg",
      "/files/images/l412018153416499.jpg",
      "/files/images/l41201815351631.jpg",
      "/files/images/l412018153516140.jpg",
      "/files/images/l412018153516234.jpg",
      "/files/images/l412018153516359.jpg",
      "/files/images/l412018153516531.jpg",
      "/files/images/l412018153516656.jpg",
      "/files/images/l412018153516796.jpg",
      "/files/images/l412018153516890.jpg",
      "/files/images/l412018153516968.jpg",
      "/files/images/l412018153616109.jpg",
      "/files/images/l412018153616202.jpg",
      "/files/images/l412018153616343.jpg",
      "/files/images/l412018153616421.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi",
    "title": "ARKADAŞLIK HAFTASI",
    "image": "/files/images/l1712201715114928.jpg",
    "description": "ARKADAŞLIK HAFTASIÇocuklar hangi yaşta olursa olsun, arkadaşlığın özel bir paylaşım olduğunu bilirler. Arkadaş edinme ve arkadaşlıkları sürdürebilme becerilerini kazanmada çocukların etrafındaki yetişkinlerin bilinçli tutumları büyük önem taşımaktadır. Bu nedenle çocuklarımızda arkadaşlık bilincini geliştirme, arkadaşlığın önemini kavrayabilme, iyi arkadaş kavramı altında paylaşımın ve yardımseverliğin gelişimini destekleyebilme adına 11 – 15 Aralık tarihleri arasında okulumuzda “ARKADAŞLIK HAFTASI” etkinlikleri planlanmıştır. Bu etkinliklerde,·        Hafta boyunca sınıflarda arkadaşlık üzerine sohbetler,·        Gün boyu okulda arkadaşlık şarkılarının dinlenmesi,·        Sabah sohbetlerinde çocukların arkadaşlarının olumlu özeliklerini ifade etmeleri,·        Öğle arası bahçede arkadaşlık boyaması ve kartı yapımı,·        Arkadaşlık konulu “Ernest & Clestine” filminin izlenmesi,·        Serbest kıyafet gününde herkesin beyaz giysiler giyip “HEPİMİZ FARKLIYIZ VE ARKADAŞIZ” duygusunun verilmesi,·        Sabah sporunda arkadaşlık dansının yapılması,·        Çocukların arkadaşlarına olan duygularını anlatan mektupların paylaşılması,·        “Benim İçin Arkadaşlık” konulu aile katılımı etkinliği,çalışmaları yapılmıştır.",
    "gallery": [
      "/files/images/l1712201715114928.jpg",
      "/files/images/l1712201715214475.jpg",
      "/files/images/l1712201715214990.jpg",
      "/files/images/l1712201715314537.jpg",
      "/files/images/l1712201715414115.jpg",
      "/files/images/l1712201715414584.jpg",
      "/files/images/l171220171551468.jpg",
      "/files/images/l1712201715514553.jpg",
      "/files/images/l171220171561484.jpg",
      "/files/images/l1712201715614193.jpg",
      "/files/images/l1712201715614303.jpg",
      "/files/images/l1712201715614397.jpg",
      "/files/images/l1712201715614475.jpg",
      "/files/images/l1712201715614568.jpg",
      "/files/images/l1712201715614662.jpg",
      "/files/images/l1712201715614787.jpg",
      "/files/images/l1712201715614912.jpg",
      "/files/images/l1712201715614975.jpg",
      "/files/images/l171220171571437.jpg",
      "/files/images/l171220171571484.jpg",
      "/files/images/l1712201715714225.jpg",
      "/files/images/l1712201715714365.jpg"
    ],
    "video": ""
  },
  {
    "id": "asya-kitasini-taniyoruz",
    "title": "ASYA KITASINI TANIYORUZ",
    "image": "/files/images/l12122017164958270.jpg",
    "description": "ASYA KITASINI TANIYORUZDünyamızı, kıtalarımızı ve ülkemizi öğreniyoruz. Kasım ayı kıtamız Asya’dan3 yaş öğrencilerimiz Kazakistan, Hindistan ; 4 yaş öğrencilerimiz Rusya, Suudi Arabistan, Azerbaycan ve 5 yaş öğrencilerimiz Japonya, Endonezya,Çin ülkelerini tanıyıp birbirlerine tanıttılar.",
    "gallery": [
      "/files/images/l12122017164958270.jpg",
      "/files/images/l12122017164958395.jpg",
      "/files/images/l12122017164958473.jpg",
      "/files/images/l12122017164958567.jpg",
      "/files/images/l12122017164958661.jpg"
    ],
    "video": ""
  },
  {
    "id": "yil-sonu-gosterisi",
    "title": "YIL SONU GÖSTERİSİ",
    "image": "/files/images/l662017112911957.jpg",
    "description": "YIL SONU GÖSTERİSİAnaokulumuzun yıl sonu gösterisi çok keyifli geçti.Tüm öğrenci ve öğretmenlerimize çok teşekkür ederiz...",
    "gallery": [
      "/files/images/l662017112911957.jpg",
      "/files/images/l66201711301198.jpg",
      "/files/images/l662017113011207.jpg",
      "/files/images/l662017113011379.jpg",
      "/files/images/l662017113011566.jpg",
      "/files/images/l662017113011723.jpg",
      "/files/images/l662017113011926.jpg",
      "/files/images/l662017113111144.jpg",
      "/files/images/l662017113111348.jpg",
      "/files/images/l662017113111535.jpg",
      "/files/images/l662017113111738.jpg",
      "/files/images/l662017113111973.jpg"
    ],
    "video": ""
  },
  {
    "id": "oyun-atolyesi",
    "title": "OYUN ATÖLYESİ",
    "image": "/files/images/l56201713228680.jpg",
    "description": "OYUN ATÖLYESİOkulumuzun bahçesinde öğrencilerimizin ingilizce konuşarak kendi deniz altı hayvanlarını tasarladıkları bir ingilizce oyun atölyesi kurduk.Our students enjoyed a wonderfully sunny afternoon spent creating their very own under-water sea creatures which they then used to populate their English play area all while speaking English.",
    "gallery": [
      "/files/images/l56201713228680.jpg",
      "/files/images/l56201713228946.jpg",
      "/files/images/l56201713328164.jpg",
      "/files/images/l56201713328352.jpg",
      "/files/images/l56201713328555.jpg",
      "/files/images/l56201713328821.jpg",
      "/files/images/l5620171342855.jpg",
      "/files/images/l56201713428289.jpg",
      "/files/images/l56201713428446.jpg",
      "/files/images/l56201713428633.jpg",
      "/files/images/l56201713428743.jpg"
    ],
    "video": ""
  },
  {
    "id": "anneler-gunu",
    "title": "Anneler Günü",
    "image": "/files/images/l16520177439475.jpg",
    "description": "Anneler GünüAnneler gününü okulumuzda çok keyifli bir etkinlikle kutladık. Tüm değerli annelerimizin anneler günü kutlu olsun...",
    "gallery": [
      "/files/images/l16520177439475.jpg",
      "/files/images/l16520177439616.jpg",
      "/files/images/l16520177439819.jpg",
      "/files/images/l1652017753938.jpg",
      "/files/images/l16520177539194.jpg",
      "/files/images/l16520177539304.jpg",
      "/files/images/l16520177539413.jpg",
      "/files/images/l16520177539507.jpg",
      "/files/images/l16520177539632.jpg"
    ],
    "video": "https://www.youtube.com/embed/Bdt1_HNIlnM?ecver=1"
  },
  {
    "id": "pazar-etkinligi",
    "title": "Pazar Etkinliği",
    "image": "/files/images/l5520179518744.jpg",
    "description": "Pazar EtkinliğiOkulumuz bahçesinde öğrencilerimizin İngilizce konuşarak keyifli bir şekilde sebze ve mevye alışverişi yapmaları için \"pazar etkinliği \" gerçekleşirdik. We set up an open-air fruit and vegetable market on our school playground for our stundent to participate  in an afternoon of shopping using English vocabulary about shopping and food.",
    "gallery": [
      "/files/images/l5520179518744.jpg",
      "/files/images/l5520179518947.jpg",
      "/files/images/l5520179528165.jpg",
      "/files/images/l5520179528384.jpg",
      "/files/images/l5520179528634.jpg"
    ],
    "video": ""
  },
  {
    "id": "sapka-festivali",
    "title": "Şapka Festivali",
    "image": "/files/images/l1842017154314337.jpg",
    "description": "Şapka FestivaliÇocuklarımızın kendi tasarladıklari şapkalarla eğlenceli bir şapka partisi gerçekleştirdik. Emekleri için hepsine teşekkür ederiz.",
    "gallery": [
      "/files/images/l1842017154314337.jpg",
      "/files/images/l1842017154314555.jpg",
      "/files/images/l1842017154314821.jpg",
      "/files/images/l1842017154314993.jpg",
      "/files/images/l1842017154414180.jpg",
      "/files/images/l1842017154414352.jpg"
    ],
    "video": ""
  },
  {
    "id": "kuzey-amerika-festivali",
    "title": "Kuzey Amerika festivali",
    "image": "/files/images/l104201712412718.jpg",
    "description": "Kuzey Amerika festivaliEğlenceli ve renkli bir Kuzey Amerika festivali ile Kuba, Meksika, ABD, Kanada, Panama ve Kostarika ülkelerini tanıdık.",
    "gallery": [
      "/files/images/l104201712412718.jpg",
      "/files/images/l10420171242282.jpg",
      "/files/images/l104201712422325.jpg",
      "/files/images/l104201712422513.jpg",
      "/files/images/l104201712422669.jpg",
      "/files/images/l104201712422794.jpg"
    ],
    "video": ""
  },
  {
    "id": "nostaji-haftasi",
    "title": "Nostaji Haftası",
    "image": "/files/images/l1042017115459341.jpg",
    "description": "Nostaji HaftasıÇocuklarımız nostalji haftasının sonunda büyükanne ve büyükbaba kıyafetlerini giyerek canlandırma yaptılar. Hep birlikte çok keyifli bir gün geçirdik. Öğrenci ve velilerimize teşekkür ederiz.",
    "gallery": [
      "/files/images/l1042017115459341.jpg",
      "/files/images/l1042017115459606.jpg",
      "/files/images/l1042017115459794.jpg",
      "/files/images/l1042017115459981.jpg",
      "/files/images/l1042017115559153.jpg",
      "/files/images/l1042017115559325.jpg"
    ],
    "video": ""
  },
  {
    "id": "nostalji-haftasinda-buyukanne-ve-buyukbabalari-agirladik",
    "title": "NOSTALJİ HAFTASINDA BÜYÜKANNE VE BÜYÜKBABALARI AĞIRLADIK.",
    "image": "/files/images/l342017223748345.jpg",
    "description": "NOSTALJİ HAFTASINDA BÜYÜKANNE VE BÜYÜKBABALARI AĞIRLADIK.Nostalji haftasında büyükanne ve büyükbabaları ağırladık.Yaptıkları keyifli etkinlikler için hepsine çok teşekkür ederiz...",
    "gallery": [
      "/files/images/l342017223748345.jpg",
      "/files/images/l342017223748564.jpg",
      "/files/images/l342017223748720.jpg",
      "/files/images/l342017223748954.jpg",
      "/files/images/l342017223848142.jpg",
      "/files/images/l342017223848314.jpg"
    ],
    "video": ""
  },
  {
    "id": "friendship-week",
    "title": "FRIENDSHIP WEEK",
    "image": "/files/images/l2132017105112579.jpg",
    "description": "FRIENDSHIP WEEKThe Importance of Friendship ; Friends are vital to preschool children’s healthy  development.  During  friendship week we prepared a good activity for our kids to take part in. We made a friendship tree all together. While we were making it we enjoyed each other's company and learned a lot of social skills such as how to communicate and cooperate.Arkadaşlığın önemi; okul öncesi çocukların, sağlıklı gelişimi için arkadaşlar çok önemlidir. Arkadaşlık haftasında çocuklar ile birlikte arkadaşlık ağacı yaptık. Yaparken çok eğlendik , işbirliği ve iletişim gibi sosyal beceriler edindik.",
    "gallery": [
      "/files/images/l2132017105112579.jpg",
      "/files/images/l2132017105112751.jpg"
    ],
    "video": ""
  },
  {
    "id": "our-five-senses",
    "title": "OUR FIVE SENSES",
    "image": "/files/images/l213201795059845.jpg",
    "description": "OUR FIVE SENSESAnasınıfı hazırlık grubu öğrencilerimizle 5 duyu organımızı tanıdık ve duyu kitabı oluşturduk.We learned  about “Our Five Senses” with our Kindergarten students and made senses books all about this topic.",
    "gallery": [
      "/files/images/l213201795059845.jpg",
      "/files/images/l21320179515947.jpg"
    ],
    "video": "https://www.youtube.com/embed/60UgViLxVJU?ecver=1"
  },
  {
    "id": "balance-game",
    "title": "BALANCE GAME",
    "image": "/files/images/l21320179556343.jpg",
    "description": "BALANCE GAMEFor kids balance games can be fun and challenging at the same time. Our 4 year-old students enjoyed keeping their balance while trying to walk on the rope.  Not only did they have a lot of fun but they also learned about shapes and colors.Denge oyunları, çocuklar için eğlenceli olduğu kadar zorlayıcı da olabilir. 4 yaş öğrencilerimiz ipin üzerinde yürümeye çalışırken hem çok eğlendiler, hemde renkleri ve şekilleri öğrendiler.",
    "gallery": [
      "/files/images/l21320179556343.jpg",
      "/files/images/l21320179556405.jpg",
      "/files/images/l21320179556499.jpg",
      "/files/images/l21320179556592.jpg",
      "/files/images/l21320179556686.jpg",
      "/files/images/l21320179556796.jpg"
    ],
    "video": ""
  },
  {
    "id": "colours-and-shapes-activities",
    "title": "COLOURS AND SHAPES ACTIVITIES",
    "image": "/files/images/l213201791353936.jpg",
    "description": "COLOURS AND SHAPES ACTIVITIESTeachers love to allow their kids to play outdoor games. In our game we made a shape like circle , triangle , rectangle , square , heart. They were excited to play this shape game.   Along with playing children were learning colors and shape recognition.  Kids loved to jump on the colorful cards.Bütün çocuklar bahçe oyunlarını çok severler. Şekiller oyunumuzda kareyi, üçgeni, dikdörtgeni , daireyi ve kalp şeklini eğlenerek öğrendik. Renkli kartların üzerine zıplamak, çocuklar için gerçekten çok eğlenceliydi.",
    "gallery": [
      "/files/images/l213201791353936.jpg",
      "/files/images/l213201791353998.jpg",
      "/files/images/l21320179145361.jpg",
      "/files/images/l213201791453139.jpg",
      "/files/images/l213201791453217.jpg"
    ],
    "video": ""
  },
  {
    "id": "dressup-class",
    "title": "DRESS-UP CLASS",
    "image": "/images2/img2_files/logo.jpg",
    "description": "DRESS-UP CLASSOur 5 year old students tried something new today.  They watched a video about clothes and then they put on some new clothes which I brought into the classroom. While putting on them , they learned the names of the clothes. After that they sang the song altogether. It was nice to see my students having a great time and trying on new clothes.5 Yaş öğrencilerimiz kıyafetler ünitesini canlandırma yaparak öğrendiler. Hem çok eğlenceli vakit geçirdiler hem de sınıfa getirilen kıyafetlerin isimlerini öğrendiler. Bu unite ile ilgili, birlikte şarkılar söyledik.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "picture-bingo",
    "title": "PICTURE BINGO",
    "image": "/files/images/l21320179949176.jpg",
    "description": "PICTURE BINGOÖzel Güney Gelişim Koleji Anaokulu İngilizce bölümü olarak  tüm yaş gruplarımızla bu zamana kadar öğrendiğimiz kelimeleri tekrar etmek amacıyla “resimli bingo yarışması” düzenledik.Hem keyif aldık hem de bilgilerimizi pekiştirdik.In order to reinforce what we have learned until this day, we played a “Bingo Picture Game”with all Kindergarten students.",
    "gallery": [
      "/files/images/l21320179949176.jpg"
    ],
    "video": ""
  },
  {
    "id": "red-day",
    "title": "RED DAY",
    "image": "/files/images/l213201792746232.jpg",
    "description": "RED DAYToday as  Gelişim Collage, the whole school celebrated Red day.  Our students were dressed beautifully in Red colored clothes.  As  teachers, we were also dressed up in Red.  Our students performed a lot of fun activities such as singing ‘’The apple is red’’ song and painting cute ladybugs. Our children were quite entertained and pretty happy to see and learn about the color Red. All the students joined in on this happy day.Gelişim Kolejinde kırmızı gününü kutladık.Öğrencilerimiz  Kırmızı renk giysiler giyindiler.Öğretmen olarak biz de kırmızı renk kıyafetler giymiştik.\"The apple is red\" şarkı söylemek ve sevimli böcekler çizmek gibi çok eğlenceli aktiviteler gerçekleştirdiler. Çocuklarımız oldukça eğlendi ve aynı anda kırmızı rengi öğrenip görmekten mutluluk duydular. Tüm öğrenciler bu mutlu güne katıldılar.",
    "gallery": [
      "/files/images/l213201792746232.jpg",
      "/files/images/l213201792746310.jpg",
      "/files/images/l213201792746388.jpg"
    ],
    "video": ""
  },
  {
    "id": "vip-kids-in-the-kitchen",
    "title": "VIP KIDS IN THE KITCHEN",
    "image": "/files/images/l213201791343169.jpg",
    "description": "VIP KIDS IN THE KITCHENVIP’s kids in the kitchen: “Lets make sandwiches’’We made yummy sandwiches in our kitchen activity. Each moment the students passed in the kitchen was enjoyable and funny.  Each student was able to prepare their own sandwich as they wanted it.  These sandwiches were especially tasty and eaten up right away.VIP çocukları mutfaktaHer dakikası çok eğlenceli bir mutfak etkinliği yaptık. Bu etkinliğin sonucu kendi sandviçlerini hazırladılar. Sandviçlerini yemek için çok sabırsızlandılar.",
    "gallery": [
      "/files/images/l213201791343169.jpg",
      "/files/images/l213201791343232.jpg"
    ],
    "video": ""
  },
  {
    "id": "yellow-day",
    "title": "YELLOW DAY",
    "image": "/files/images/l213201792740794.jpg",
    "description": "YELLOW DAYGelişim koleji Anaokulu  olarak “Sarı Günü” düzenledik.Bütün öğrencilerimiz okula sarı giyinip geldiler ve sarı rengi ile ilgili aktiviteler yapıp şarkılar söylediler.We organized a “Yellow Day” in our school.All of the students wore yellow clothes.We did activities and learned songs about the color yellow.",
    "gallery": [
      "/files/images/l213201792740794.jpg"
    ],
    "video": ""
  },
  {
    "id": "vip-kahvalti-etkinligi",
    "title": "VİP KAHVALTI ETKİNLİĞİ",
    "image": "/files/images/l1722017115547303.jpg",
    "description": "VİP KAHVALTI ETKİNLİĞİ5 Ekim Cumartesi günüanaokulu öğrencilerimiz ve velilerimizin katılımıyla , okulumuzun bahçesinde çok güzel bir 'Kahvaltı Etkinliği' gerçekleştirdik. Bu keyifli günü bizlerle paylaşan tüm öğrenci ve velilerimize teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l1722017115547303.jpg",
      "/files/images/l1722017115547381.jpg",
      "/files/images/l1722017115547460.jpg",
      "/files/images/l1722017115547522.jpg",
      "/files/images/l1722017115547600.jpg",
      "/files/images/l1722017115547678.jpg",
      "/files/images/l1722017115547756.jpg",
      "/files/images/l1722017115547835.jpg",
      "/files/images/l1722017115547897.jpg",
      "/files/images/l1722017115547975.jpg",
      "/files/images/l172201711564753.jpg"
    ],
    "video": ""
  },
  {
    "id": "vip-anaokulu-ataturk-evine-gezi",
    "title": "VİP ANAOKULU ATATÜRK EVİNE GEZİ",
    "image": "/files/images/l172201711745600.jpg",
    "description": "VİP ANAOKULU ATATÜRK EVİNE GEZİAtamızın Mersin'e geldiği zaman kaldığı evi ziyaret ettik. Atatürk'ün kişisel eşyalarını, fotoğraflarını inceledik. Çok ilgimizi çekti.ATAMIZI SAYGIYLA ANIYORUZ.",
    "gallery": [
      "/files/images/l172201711745600.jpg",
      "/files/images/l172201711745694.jpg",
      "/files/images/l172201711745772.jpg",
      "/files/images/l172201711745850.jpg"
    ],
    "video": ""
  },
  {
    "id": "vip-anaokulu-10-kasim-toreni",
    "title": "VİP ANAOKULU 10 KASIM TÖRENİ",
    "image": "/files/images/l1722017113143976.jpg",
    "description": "VİP ANAOKULU 10 KASIM TÖRENİ10 KASIM ATATÜRK'Ü ANMA TÖRENİAtamızı saygıyla andık.Atam seni unutmadık, unutmayacağız.",
    "gallery": [
      "/files/images/l1722017113143976.jpg",
      "/files/images/l172201711324368.jpg",
      "/files/images/l1722017113243193.jpg",
      "/files/images/l1722017113243334.jpg"
    ],
    "video": ""
  },
  {
    "id": "okul-oncesi-semineri",
    "title": "OKUL ÖNCESİ SEMİNERİ",
    "image": "/files/images/l1722017112940599.jpg",
    "description": "OKUL ÖNCESİ SEMİNERİRehber Öğretmenimiz Sibel BALDİL’in sunduğu “Okul Öncesi Dönemde Yaşanan Sorunlar” konulu seminerimiz ve çocuklarımızın resimlerinden oluşan resim sergimiz çok keyifli geçti. Katılan tüm velilerimize çok teşekkür ederiz.",
    "gallery": [
      "/files/images/l1722017112940599.jpg",
      "/files/images/l1722017112940693.jpg",
      "/files/images/l1722017112940755.jpg",
      "/files/images/l1722017112940834.jpg",
      "/files/images/l1722017112940912.jpg",
      "/files/images/l1722017112940990.jpg",
      "/files/images/l172201711304084.jpg",
      "/files/images/l1722017113040224.jpg",
      "/files/images/l1722017113040334.jpg"
    ],
    "video": ""
  }
];